import ApplicationAdapter from "./application";

export default class ShipmentAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/shipment/create`;
  }

  urlForUpdateRecord(id, modelName, snapshot) {
    let action = snapshot.adapterOptions?.action ?? "cancel";
    return `${this.apiBaseUri}/shipment/${action}?key=${id}`;
  }
}
